export const width=502;export const height=302;export default{width:width,height:height};